export const features = [
  'channels',
  'dataTypes',
  'purposeTypes',
  'productTypes',
] as const;

export type FeatureType = typeof features[number];
